import { on } from 'delegated-events';
import { scrollToElement } from '../scroll-to-element';

import OptionChooser from '../product-detail/option-chooser';
import MainGallery from '../product-detail/main-product-gallery';
import AmountHandler from '../amount-handler';
import AvailabilityPopup from '../availability-popup';
import DescNavigation from '../desc-navigation';

export default function () {
    MainGallery();
    OptionChooser();
    AmountHandler();
    AvailabilityPopup();
    DescNavigation();
    ScrollToComments();

    // VARIOUS BELOW
    // DETAIL ACCORDION
    on('click', '.detail-accordion-trigger', function () {
        this.classList.toggle('info-visible');
    });

}

function ScrollToComments() {
    const scrollTrigger = document.querySelector("[data-scroll-to-comments]");
    if (!scrollTrigger) return;
    const target = document.querySelector('#detail-comments');
    if (!target) return;

    scrollTrigger.style.cursor = 'pointer';
    scrollTrigger.addEventListener('click', function () {
        scrollToElement(target);
    });
}